import React from 'react'
import { ViewComp, ViewProps } from 'src/ui/basic/api/View'
import { css } from 'src/ui/style/css'

export const View: React.FC<ViewProps> = ({
    id,
    children,
    className,
    onClick,
    horizontal = false
}) => (
    <div
        id={id}
        onClick={onClick}
        css={css`
            display: flex;
            flex-direction: ${horizontal ? 'row' : 'column'};
            align-items: ${horizontal ? 'center' : ''};
            justify-content: center;
        `}
        className={className}
    >
        {children}
    </div>
)
